export default "__VITE_ASSET__DRvhjRB7__"